<template>
  <Modal :open="open" :border="false" :backdrop-close="false" :classes="{ modalContent: 'max-md:!h-auto' }" @on-close="closeModal">
    <template #body>
      <h1 class="text-lg font-semibold text-app-gray-900">Help improve Web3Auth’s Products</h1>
      <p class="text-sm font-normal text-app-gray-500 !mt-2">
        Your feedback is valuable to us as we constantly strive to improve our product and services.
      </p>
      <Select
        id="FeedbackType"
        :options="[]"
        label="What type of feedback would you like to provide?"
        aria-labelledby="Type of Feedback"
        class="!mt-4 !mb-5"
      />
      <p class="text-sm font-medium text-app-gray-900 mb-4 !mt-0">How would you rate your experience with Web3Auth?</p>
      <div class="flex gap-6 mb-6">
        <Icon v-for="(_, idx) in Array(5).fill('')" :key="idx" name="happy-icon" class="cursor-pointer" />
      </div>
      <TextArea
        id="Comments"
        label="Comments & Additional Feedback (optional)"
        placeholder="Tell us more about your experience with us or how we can make your experience better."
        :classes="{ textAreaInput: 'cursor-text' }"
        rows="10"
      />
      <p class="text-sm font-medium text-app-gray-900 !mb-4 mt-5">Allow Web3Auth to contact me about my feedback</p>
      <Radio id="allow-contact" label="Yes" class="!mt-0" />
      <Radio id="do-not-allow-contact" label="No" class="!mt-2" />
      <div class="flex gap-8 justify-end items-center">
        <Button variant="secondary" class="!text-app-gray-900 !text-base !font-medium" @click="closeModal">Cancel</Button>
        <Button>Submit Feedback</Button>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Icon } from "@toruslabs/vue-components/Icon";
import { Modal } from "@toruslabs/vue-components/Modal";
import { Radio } from "@toruslabs/vue-components/Radio";
import { defineComponent } from "vue";

import { Button } from "@/components/Button";
import { Select } from "@/components/Select";
import { TextArea } from "@/components/TextArea";

export default defineComponent({
  name: "FeedbackModal",
  components: { Button, Icon, Modal, Radio, Select, TextArea },
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["onClose"],
  methods: {
    closeModal() {
      this.$emit("onClose");
    },
  },
});
</script>
